var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.106,
    y1: 0.795,
    x2: 0.869,
    y2: 0.181,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8348cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e76445"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13734",
    "data-name": "Group 13734",
    transform: "translate(-1860 -835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13095",
    "data-name": "Path 13095",
    d: "M28,0A28,28,0,1,1,0,28,28,28,0,0,1,28,0Z",
    transform: "translate(1860 835)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13149",
    "data-name": "Path 13149",
    d: "M176.53,267l3.583,2.558-2.191,2.631a7.63,7.63,0,0,1,2.071,5.492,7.272,7.272,0,0,1-4.143,6.916,6.235,6.235,0,0,1,4.063,6.129c0,5.115-4.143,8.273-9.837,8.273s-9.961-3.274-9.961-8.279h4.821c0,2.408,2.349,3.99,5.137,3.99s4.98-1.427,4.98-3.99S172.506,287,170.074,287c-6.137,0-9.961-3.534-9.961-9.324s4.462-9.4,9.961-9.4a8.186,8.186,0,0,1,4.5,1.053Zm-11.592,10.681a5.118,5.118,0,1,0,10.237,0,5.119,5.119,0,1,0-10.237,0",
    transform: "translate(1717.887 580)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGPink);
export default __webpack_public_path__ + "static/media/gPink.5e911e189b36a4f042a6d31a50492b4b.svg";
export { ForwardRef as ReactComponent };